/**
 * Format tiền
 * @param {*} value
 */
export default {
  amountFormat(value) {
    if (value != null) {
      // const currentBranch = branchContext.getCurrentBranch();
      const currentBranch = null;
      const groupSeparator = currentBranch?.GeneralGroupSeparator ?? ',';
      const decimalSeparator = currentBranch?.GeneralDecimalSeparator ?? '.';
      const decimalDigits = currentBranch?.AmountDecimalDigits ?? 0;
      const symbol = currentBranch?.SymbolCurrency ?? 'đ';
      const positionCurrency = currentBranch?.PositionCurrency ?? 1;
      let fotmatedNumber = value.numberFormat(
        decimalDigits,
        decimalSeparator,
        groupSeparator
      );
      if (positionCurrency == 0) {
        fotmatedNumber = symbol + fotmatedNumber;
      } else if (positionCurrency == 1) {
        fotmatedNumber = fotmatedNumber + symbol;
      } else if (positionCurrency == 2) {
        fotmatedNumber = symbol + ' ' + fotmatedNumber;
      } else {
        fotmatedNumber = fotmatedNumber + ' ' + symbol;
      }
      return fotmatedNumber;
    }
  },
};
